module.exports = __webpack_public_path__ + "img/p5.ce4a7a27.png";